export default "__VITE_ASSET__BFRLWKwK__"